<template>
<!--  :style="styles"-->
  <svg
    class="logo"

    viewBox="0 0 92 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- eslint-disable vue/max-len -->
    <path
      d="M59.1743 6.48909c.0003.85173-.1711 1.69516-.5042 2.48211-.3332.78694-.8217 1.502-1.4376 2.1042-.6158.6023-1.347 1.08-2.1517 1.4058-.8048.3258-1.6672.4934-2.5382.4931-2.7241 0-5.3054-2.2979-8.2696-2.2979-2.9621 0-5.5369 2.2979-8.2696 2.2979-1.7589 0-3.4457-.6833-4.6894-1.8995-1.2436-1.21619-1.9423-2.86573-1.9423-4.58571 0-1.71997.6987-3.36951 1.9423-4.58572C32.5577.68717 34.2445.00391 36.0034.00391c2.7327 0 5.3075 2.11588 8.2696 2.11588 2.9642 0 5.5455-2.11588 8.2696-2.11588.871-.00028 1.7334.16727 2.5382.49309.8047.3258 1.5359.80349 2.1517 1.40575.6159.60227 1.1044 1.3173 1.4376 2.10424.3331.78695.5045 1.63038.5042 2.4821ZM21.6754 1.16553c-.3633-.36828-.7987-.6612-1.2803-.86126-.4816-.20006-.9995-.30317-1.5227-.30317-.5233 0-1.0412.1031-1.5228.30317-.4816.20007-.917.49298-1.2803.86126l-2.1637 2.18571-2.1637-2.18571c-.3633-.3686-.7988-.6618-1.2806-.86206C9.97945.10321 9.46131 0 8.93779 0c-.52351 0-1.04166.10321-1.52346.30347-.4818.20026-.91737.49345-1.28068.86206L1.17881 6.17594C.42291 6.9359 0 7.95424 0 9.0144c0 1.0602.42291 2.0785 1.17881 2.8385.3633.3686.79887.6618 1.28068.862.4818.2003.99994.3035 1.52346.3035.52351 0 1.04166-.1032 1.52346-.3035.4818-.2002.91737-.4934 1.28068-.862l2.16368-2.17728 2.14203 2.17728c.3658.3675.8031.6596 1.2862.859.4831.1995 1.0022.3023 1.5266.3023s1.0435-.1028 1.5266-.3023c.4831-.1994.9205-.4915 1.2862-.859l2.1637-2.17728 2.1442 2.17728c.3633.3686.7989.6618 1.2807.862.4818.2003.9999.3035 1.5235.3035.5235 0 1.0416-.1032 1.5234-.3035.4818-.2002.9174-.4934 1.2807-.862.7517-.76 1.1719-1.7759 1.1719-2.83321 0-1.05729-.4202-2.07319-1.1719-2.83317l-4.9592-5.02099Zm55.7626 0c-.3633-.3686-.7989-.6618-1.2807-.86206C75.6755.10321 75.1574 0 74.6338 0c-.5235 0-1.0416.10321-1.5234.30347-.4818.20026-.9174.49345-1.2807.86206l-2.1529 2.17724-2.1637-2.17724c-.3633-.3686-.7988-.6618-1.2806-.86206S65.2325 0 64.709 0c-.5235 0-1.0417.10321-1.5235.30347-.4818.20026-.9173.49345-1.2806.86206-.7527.75946-1.1736 1.77556-1.1736 2.83317s.4209 2.0737 1.1736 2.83317l4.9591 5.02103c.3636.3712.8002.6666 1.2836.8684.4834.2019 1.0036.3059 1.5292.3059.5256 0 1.0458-.104 1.5292-.3059.4834-.2018.9201-.4972 1.2836-.8684l4.9592-5.01045c.7534-.76185 1.1737-1.78077 1.1717-2.84061-.002-1.05984-.4262-2.07722-1.1825-2.83631Zm13.3954 0c-.3633-.3686-.7989-.6618-1.2807-.86206C89.0709.10321 88.5527 0 88.0292 0c-.5235 0-1.0416.10321-1.5234.30347-.4818.20026-.9174.49345-1.2807.86206l-4.9462 5.01041c-.7554.76022-1.178 1.77846-1.178 2.83846s.4226 2.0782 1.178 2.8385c.3633.3686.7989.6618 1.2807.862.4818.2003.9999.3035 1.5234.3035.5236 0 1.0417-.1032 1.5235-.3035.4818-.2002.9174-.4934 1.2807-.862l4.957-5.00834c.753-.76246 1.173-1.78163 1.171-2.84166-.002-1.06003-.4259-2.07766-1.1818-2.83737Z"
      fill="#F05033"
    />
  </svg>
</template>

<script>
const sizes = {
  little: {
    width: '92px',
    height: '13px',
  },

  big: {
    width: '177px',
    height: '25px',
  },
};
export default {
  name: 'VLogo',
  props: {
    size: {
      type: String,
      default: 'little',
    },
  },

  computed: {
    styles() {
      return sizes[this.size];
    },
  },
};
</script>
